<template>
    <div class="progress-bar">
        <div class="progress-bar__container">
            <div v-for="(step, index) in steps" :key="index" class="progress-bar__step" :class="{
                'progress-bar__step--active': index <= currentStep,
                'progress-bar__step--completed': index < currentStep
            }">
                <template v-if="!step.children">
                    <div class="progress-bar__row">
                        <div class="progress-bar__label" :class="{ 'progress-bar__label--sm': size === 'sm' }">
                            {{ step.title }}
                        </div>
                        <div class="progress-bar__line" :class="{ 'progress-bar__line--sm': size === 'sm' }"></div>
                    </div>
                </template>

                <template v-else>
                    <div class="progress-bar__row">
                        <div class="progress-bar__label progress-bar__label--sm">
                            {{ step.title }}
                        </div>
                        <div class="progress-bar__line-child-wrapper">
                            <div v-for="(child, cIndex) in step.children" :key="cIndex">
                                <div class="progress-bar__line-child" :class="{
                                    'progress-bar__line-child--active': isChildActive(child.code),
                                    'progress-bar__line-child--completed': isChildCompleted(child.code)
                                }"></div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    steps: {
        type: Array,
        required: true,
        default: () => []
    },
    currentStep: {
        type: Number,
        default: 0
    },
    size: {
        type: String,
        default: 'md'
    },
    index: {
        type: Boolean,
        default: false
    },
    currentCode: {
        type: String,
        default: ""
    }
})

const isChildActive = (code) => {
    return props.currentCode === code
}
const isChildCompleted = (code) => {
    return false
}
</script>

<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;

.progress-bar {
    width: 100%;
    padding: 0;

    &__container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
    }

    &__step {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        min-width: 0;
    }

    &__label {
        font-size: 14px;
        font-weight: 500;
        color: $gray;
        text-align: left;
        white-space: nowrap;
        margin-bottom: 8px;

        .progress-bar__step--active & {
            color: #0060FE;
            font-weight: 600;
        }

        .progress-bar__step--completed & {
            color: #0060FE;
            font-weight: 600;
        }

        &--sm {
            font-size: 10px;
        }
    }

    &__line {
        width: 100%;
        height: 3px;
        background-color: $gray-light;
        border-radius: 2px;

        .progress-bar__step--active & {
            background-color: #0060FE;
        }

        .progress-bar__step--completed & {
            background-color: #0060FE;
        }

        &--sm {
            height: 2px;
        }
    }
}

.progress-bar__line-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
}

.progress-bar__line-child-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: 8px;
}

.progress-bar__label {
    display: inline-block;
}

.progress-bar__line-child-wrapper>div {
    flex: 1 1 0;
    min-width: 0;
}

.progress-bar__line-child {
    height: 3px;
    background-color: #e0e0e0;
    border-radius: 2px;
    width: 100%;
}

.progress-bar__line-child--active,
.progress-bar__line-child--completed,
.progress-bar__step--active .progress-bar__line,
.progress-bar__step--completed .progress-bar__line {
    background-color: #0060fe;
}

@media (max-width: 768px) {
    .progress-bar {
        &__container {
            flex-direction: column;
            gap: 16px;
        }

        &__step {
            width: 100%;
        }

        &__label {
            white-space: normal;
        }
    }
}
</style>
